import { GetLogProcessResultService } from './api-services/get-log-process-result.service';
import { KYMW0D01Component } from './../kymw0d01/kymw0d01.component';
import { DeleteLogProcessResultService } from './api-services/delete-log-process-result.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { FileDownloadConfirmService } from './../../kymw02/file-download-confirm/file-download-confirm.service';
import { PlessViewUtilsSub } from './../../kymw00/pless-view-utils-sub.service';
import { MakeLogDataService } from './api-services/make-log-data.service';
import { KYMW0D00InputModel } from './vo/kymw0d00-input.model';
import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW0D00Model } from './kymw0d00.model';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { WjFlexGrid } from '@grapecity/wijmo.angular2.grid';

/**
 * 処理ログ画面を管理するクラス
 *
 * @export KYMW0D00Component
 * @class KYMW0D00Component
 */
@Component({
  selector: 'app-kymw0d00',
  templateUrl: 'kymw0d00.component.html',
  styleUrls: ['kymw0d00.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0D00Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('btn_Output', { static: true }) btn_Output: ElementRef;
  @ViewChild('dtg_LogList', { static: true }) dtg_LogList: WjFlexGrid;

  // 親画面からの連携値
  param: any;

  kymw0D00Model: KYMW0D00Model = new KYMW0D00Model();

  /**
	 * 受渡情報ＶＯ
	 */
  public inputVO: KYMW0D00InputModel;

  /**
   *Creates an instance of KYMW0D00Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0D00Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    private makeLogDataService: MakeLogDataService,
    private deleteLogProcessResultService: DeleteLogProcessResultService,
    public getLogProcessResultService: GetLogProcessResultService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0D00Component
   */
  public ngOnInit(): void {
    this.kymw0D00Model.kymw0D00Component = this;
    this.componentName = 'KYMW0D00';

    // 受渡情報をmanageに設定
    this.kymw0D00Model.kymw0D00InputVO = this.inputVO;

    // 処理ログ一覧をクリア
    this.kymw0D00Model.logList = null;
    this.kymw0D00Model.btnOutputEnabled = false;

    if (this.checkRequiredParam()) {
      // 処理結果ログ取得処理を起動
      this.getLogProcessResultService.execute(this.kymw0D00Model, this.kymw0D00Model.getLogProcessResultVO(),
        () => this.eventInitLoadSuccess());
    }

    this.dtg_LogList.itemsSourceChanged.addHandler(() => {
      this.dtg_LogList.select(-1, -1);
    });
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0D00Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = <KYMW0D00InputModel>param;
  }

  /**
	 * init_loadの正常終了後に起動
	 */
  public eventInitLoadSuccess(): void {
    //  異常件数が1以上の場合、件数情報を表示
    if (this.inputVO.abnormalNum > 0) {
      // 実績履歴画面を起動
      const componentRef = this.dialogService.openModal(KYMW0D01Component);
      const instance = componentRef.componentInstance as KYMW0D01Component;
      instance.parent = this;
      instance.setInterfaceParam(this.kymw0D00Model.kymw0D00InputVO);
      instance.closeFunction = () => {
        componentRef.close();
      };
    }

    setTimeout(() => {
      this.plessEnabledSetting();
    });
    this.dtg_LogList.focus();

  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   *
   */
  public eventOutput_CLICKHandler(event: MouseEvent): void {
    // 処理結果データ出力処理を起動
    const vo = this.kymw0D00Model.makeLogDataVO();
    this.makeLogDataService.execute(this.kymw0D00Model, vo, (data) => {
      // ファイル名の設定
      const fileName = vo.localfile + '_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.TXT';

      this.fileDownloadConfirmService.show(data.FileURL, fileName);
      // ファイル出力後フラグを更新
      this.kymw0D00Model.outputFile = true;
    });
  }

  /**
   * 閉じるボタンを押下した時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   */
  public eventCloseWindow_ClickHandler(event: Event): void {
    if (!this.kymw0D00Model.outputFile) {
      this.dialogService.openAlertGetMessage('Q0139', [''], (closeEvent) => {
        if (closeEvent === PlessAlert.Yes) {
          this.eventCloseWindow_YESHandler();
        }
      });
    } else {
      this.eventCloseWindow_YESHandler();
    }
  }

  /**
   * 終了確認後に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   */
  public eventCloseWindow_YESHandler(): void {
    // 処理結果ログ削除処理を起動
    this.deleteLogProcessResultService.execute(this.kymw0D00Model.deleteLogProcessResultVO());

    // 『処理ログ』画面終了
    super.onClickClose();
  }

  /**
  * 受渡項目の必須チェック
  */
  public checkRequiredParam(): boolean {
    if (PlessViewUtilsSub.isEmpty(this.kymw0D00Model.kymw0D00InputVO.dispId)) {
      return false;
    }
    return true;
  }

  /**
   * 活性・非活性制御処理
   *
   * @memberof KYMW0800Component
   */
  plessEnabledSetting() {
    this.plessEnabled(this.btn_Output, this.kymw0D00Model.btnOutputEnabled);
  }
}
